export default "__VITE_ASSET__DS_d3EUY__"